import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  sendOtp,
  verifyOtp,
  logout,
  sendEmailOTP,
  verifyEmailOTP,
  getPublicComments,
} from "../../services/apiEndpoints";
import {
  SendEmailOtpPayload,
  SendOtpPayload,
  VerifyEmailOtpPayload,
  VerifyOtpPayload,
} from "../../types";

export const sendOtpThunk = createAsyncThunk(
  "login/sendOtp",
  async (payload: SendOtpPayload, { rejectWithValue }) => {
    try {
      const response = await sendOtp(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data || error.message || "Failed data is not loaded"
      );
    }
  }
);

export const verfiyOtpThunk = createAsyncThunk(
  "login/verifyOtp",
  async (payload: VerifyOtpPayload, { rejectWithValue }) => {
    try {
      const response = await verifyOtp(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data || error.message || "Failed data is not loaded"
      );
    }
  }
);

export const sendEmailOtpThunk = createAsyncThunk(
  "login/sendEmailOtp",
  async (payload: SendEmailOtpPayload, { rejectWithValue }) => {
    try {
      const response = await sendEmailOTP(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data || error.message || "Failed data is not loaded"
      );
    }
  }
);

export const verifyEmailOtpThunk = createAsyncThunk<
  any, // response type (replace with actual type if you have)
  VerifyEmailOtpPayload,
  { rejectValue: any }
>("login/verifyEmailOtp", async (payload, { rejectWithValue }) => {
  try {
    const response = await verifyEmailOTP(payload);
    return response.data;
  } catch (error: any) {
    return rejectWithValue(
      error.response?.data || error.message || "Failed to verify email OTP"
    );
  }
});

export const logoutThunk = createAsyncThunk(
  "login/logout",
  async (_, { rejectWithValue }) => {
    try {
      const response = await logout();
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data || error.message || "Failed data is not loaded"
      );
    }
  }
);
export const getPublicCommentsThunk = createAsyncThunk(
  "ca/getPublicComments",
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await getPublicComments(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data || error.message || "Failed data is not loaded"
      );
    }
  }
);
